<template>
  <a-card :bordered="false">
    <div class="table-page-search-wrapper">
      <a-form layout="inline">
        <a-row :gutter="48">
          <a-col :md="6" :sm="24">
            <a-form-item label="关键字">
              <a-input
                v-model="queryParam.keywords"
                allowClear
                placeholder="搜索关键字"
              />
            </a-form-item>
          </a-col>
          <!-- <a-col :md="6" :sm="24">
            <a-form-item label="赛季">
              <a-select
                v-model="queryParam.saiji"
                placeholder="请选择"
                allowClear
              >
                <a-select-option
                  v-for="(option, index) in saijiOptions"
                  :value="option.id"
                  >{{ option.name }}
                </a-select-option>
              </a-select>
            </a-form-item>
          </a-col> -->

          <template v-if="advanced">
            <a-col :md="6" :sm="24">
              <a-form-item label="授权编号">
                <a-input
                  v-model="queryParam.kaojiregist_code"
                  placeholder="搜索授权编号"
                />
              </a-form-item>
            </a-col>
            <a-col :md="6" :sm="24">
              <a-form-item label="单位名称">
                <a-input
                  v-model="queryParam.danwei"
                  placeholder="搜索单位名称"
                />
              </a-form-item>
            </a-col>

            <a-col :md="6" :sm="24">
              <a-form-item label="考试时间">
                <a-range-picker
                  v-model="time_range_moment"
                  style="width: 100%"
                  format="YYYY-MM-DD HH:mm:ss"
                  :showTime="{
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('23:59:59', 'HH:mm:ss'),
                    ],
                  }"
                />
              </a-form-item>
            </a-col>
          </template>
          <a-col :md="(!advanced && 6) || 24" :sm="24">
            <span
              class="table-page-search-submitButtons"
              :style="
                (advanced && { float: 'right', overflow: 'hidden' }) || {}
              "
            >
              <a-button type="primary" @click="onSearch">查询</a-button>
              <a-button
                style="margin-left: 8px"
                @click="() => (queryParam = {})"
                >重置</a-button
              >
              <a @click="toggleAdvanced" style="margin-left: 8px" v-if="false">
                {{ advanced ? "收起" : "展开" }}
                <a-icon :type="advanced ? 'up' : 'down'" />
              </a>
            </span>
          </a-col>
        </a-row>
      </a-form>
    </div>

    <div class="table-operator">
      <a-button type="primary" icon="plus" @click="addHandle">新建</a-button> 
      <!-- <a-button   icon="download" @click="saijiDownloads('saijiSaiquTable')" >赛季赛事统计表</a-button> -->
      <!-- <a-button   icon="download" @click="saijiDownloads('saijiProvinceMemberAgeTable')" >赛季省份人员分布表</a-button> -->
      <!-- <a-button   icon="download" @click="saijiDownloads('saijiSaiquMonthTable')" >赛区月份分布表</a-button> -->
      <!-- <a-button   icon="download" @click="saijiDownloads('saijiSaiquProvinceTable')" >赛区省份汇总表</a-button> -->
      <!-- <a-button   icon="download" @click="saijiDownloads('saijiKaojiZhongxinTable')" >赛季考级中心考级点俱乐部报名占比表</a-button> -->
      <!-- <a-button   icon="download" @click="saijiDownloads('saijiDengjizuTable')" >赛季运动员等级组报名占比表</a-button> -->
      <!-- <a-button   icon="download" @click="saijiDownloads('saijiSuiduicaipanTable')" >随队裁判报名占比表</a-button> -->
      <!-- <a-button   icon="download" @click="saijiDownloads('saijiYdySexTable')" >运动员性别名占比表</a-button> -->
      <!--<a-button type="primary" icon="plus" @click="applyVisible=true" >申请办赛</a-button>-->
    </div>

    <s-table
      ref="table"
      size="default"
      :columns="columns"
      :data="loadData"
      :alert="{
        show: true,
        clear: () => {
          this.selectedRowKeys = [];
        },
      }"
      :rowSelection="{
        selectedRowKeys: selectedRowKeys,
        onChange: onSelectChange,
      }"
    >
      <span slot="name" slot-scope="text, record">
        <div style="margin-left: 10px; float: left">
          {{ record.name }}
          <br />
          <!-- <span style="color: #999"
            >{{ record.province }}{{ record.city }}{{ record.county }}</span
          > -->
          <!-- <br /> -->
          举办时间 {{ record.saidate | timeFormat }}
          <br /> 
 
        </div>
      </span>
      <span slot="status" slot-scope="text, record">
        开始报名 {{ record.stime | timeFormat }}
        <br />
        结束报名 {{ record.etime | timeFormat }}
        <br />

        <a-tag v-if="record.status == 1" color="green">进行中</a-tag>
        <a-tag v-else>未进行</a-tag>
        <a-tag v-if="record.type == 1" color="green">显示</a-tag>
        <a-tag v-else>不显示</a-tag>
      </span>
      <span slot="action" slot-scope="text, record">
        <template>
          <a @click="handleEdit(record)">编辑</a>
          <a-divider type="vertical" />
          <!--<a @click="handleDate(record)">日程安排</a>-->
          <!--<a-divider type="vertical" />-->
          <a-dropdown>
            <a class="ant-dropdown-link"> 更多 <a-icon type="down" /> </a>
            <a-menu slot="overlay">
              <!-- <a-menu-item>
                <a @click="handleDocument(record)">相关文件</a>
              </a-menu-item> -->

              <a-menu-item>
                <a @click="handleRoomType(record)">房型配置</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleStation(record)">车站机场配置</a>
              </a-menu-item>
              <!-- <a-menu-item>
                <a @click="handleZhixingguan(record)">执行官</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleCcaren(record)">负责人</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleUserList(record)">赛区合伙人</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleMiniCode(record)">投票分享</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="handleVisit(record)">点击统计</a>
              </a-menu-item> -->
              <!-- <a-menu-item>
                <a-popconfirm
                  title="删除后不可恢复,确定删除吗?"
                  @confirm="deleteHandle(record)"
                  okText="确定"
                  cancelText="取消"
                >
                  <a href="javascript:;">删除</a>
                </a-popconfirm>
              </a-menu-item> -->
            </a-menu>
          </a-dropdown>

          <!-- <a-divider type="vertical" />
                    <a-dropdown>
            <a class="ant-dropdown-link"> 下载 <a-icon type="down" /> </a>
            <a-menu slot="overlay"> 
              <a-menu-item>
                <a @click="saiquDownloads('saiquSubjectHuaqiuTable',record)">花球等项目占比表</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="saiquDownloads('saiquSubjectWudaoTable',record)">舞蹈等项目占比表</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="saiquDownloads('saiquSubjectYdyCountTable',record)">运动员报名项目数表</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="saiquDownloads('saiquJiaolianCertTable',record)">教练员持证数表</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="saiquDownloads('saiquScorePenTable',record)">项目减分情况表</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="saiquDownloads('saiquProjectSomeCountTable',record)">项目队伍报名情况表</a>
              </a-menu-item>
              <a-menu-item>
                <a @click="saiquDownloads('saiquDengjizuTable',record)">运动员等级组报名占比表</a>
              </a-menu-item>
               
            </a-menu>
          </a-dropdown> -->

        </template>
      </span>
    </s-table>

    <a-modal
      :maskClosable="false"
      title="操作"
      :width="1200"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="visible"
      @ok="handleOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="名称"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'name',
                    { rules: [{ required: true, message: '请输入名称' }] },
                  ]"
                  placeholder="请输入名称"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="赛季"
                hasFeedback
              >
                <a-select
                  :disabled="formData.id > 0"
                  v-model="formData.saiji"
                  placeholder="请选择"
                  allowClear
                >
                  <a-select-option
                    v-for="(option, index) in saijiOptions"
                    :value="option.id"
                    >{{ option.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
          </a-row>


          <!-- <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="赛事类型"
                hasFeedback 
              >
                <a-radio-group v-model="formData.project_type" buttonStyle="solid">
                  <a-radio-button :value="1">毽球</a-radio-button>
                  <a-radio-button :value="2">跳绳</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
          </a-row> -->

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="所在地区"
                hasFeedback
              >
                <a-cascader
                  :options="areaOptions"
                  placeholder="请选择地区"
                  v-model="formData.areas"
                  changeOnSelect
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
 
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="级别"
                hasFeedback
              >
                <a-radio-group v-model="formData.level" buttonStyle="solid">
                  <a-radio-button :value="1">全国</a-radio-button>
                  <a-radio-button :value="2">其他</a-radio-button> 
                </a-radio-group> 
              </a-form-item>  

              <a-form-item
                v-show="false"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="是否进行"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="status"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="是"
                  unCheckedChildren="否"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="是否显示"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="type"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="是"
                  unCheckedChildren="否"
                />
              </a-form-item>
            </a-col>
            <!-- <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="项目配置"
                hasFeedback
              >
                <a-select
                  showSearch
                  allowClear
                  v-model="formData.subjecttype"
                  optionFilterProp="title"
                  placeholder="选择"
                >
                  <a-select-option
                    :key="option.id"
                    :title="option.name"
                    v-for="option in subjectTypeOptions"
                    :value="option.id"
                    >{{ option.name }}
                  </a-select-option>
                </a-select>
              </a-form-item>
            </a-col> -->
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="比赛时间"
                hasFeedback
              >
                <a-range-picker
                  v-model="formData.saidate_moment"
                  format="YYYY-MM-DD"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="报名时间"
                hasFeedback
              >
                <a-range-picker
                  v-model="formData.time_range_moment"
                  :showTime="{
                    defaultValue: [
                      moment('00:00:00', 'HH:mm:ss'),
                      moment('23:59:59', 'HH:mm:ss'),
                    ],
                  }"
                  format="YYYY-MM-DD HH:mm:ss"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
             

            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="队伍名称后缀"
                hasFeedback
              >
                <a-input
                  v-model="formData.mingcheng_end"
                  placeholder="如啦啦操队"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <!-- <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="赛事服务费"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'memberoneprice',
                    {
                      rules: [{ required: true, message: '请输入赛事服务费' }],
                    },
                  ]"
                  placeholder="请输入赛事服务费"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="报名咨询二维码"
                hasFeedback
              >
                <pic-uploader :numberLimit="1" :file-list="formData.erweiimg" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="线下收款账号"
                hasFeedback
              >
                <a-textarea
                  v-model="formData.third_pay_info"
                  :rows="4"
                  placeholder="请输入线下收款账号信息"
                />
              </a-form-item>
            </a-col>
          </a-row> -->

          <!-- <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="信息核对联系人二维码"
                hasFeedback
              >
                <pic-uploader
                  :numberLimit="1"
                  :file-list="formData.erweiimg2"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="线下收款二维码"
                hasFeedback
              >
                <pic-uploader
                  :numberLimit="1"
                  :file-list="formData.pay_pic"
                />
              </a-form-item>
            </a-col>
          </a-row> -->
          <!-- <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="赛事负责人"
                hasFeedback
              >
                <a-input
                  v-decorator="['fuzeren', { rules: [] }]"
                  placeholder="请输入姓名手机"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24"> </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="赛事咨询联系人"
                hasFeedback
              >
                <a-input
                  v-decorator="['zixunren', { rules: [] }]"
                  placeholder="请输入姓名手机"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24"> </a-col>
          </a-row> -->

          <a-row :gutter="48" v-show="false">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="小图"
                hasFeedback
                extra="推荐尺寸400x400"
              >
                <pic-uploader :numberLimit="1" :file-list="formData.pic" />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="大图"
                hasFeedback
                extra="推荐尺寸1000x430"
              >
                <pic-uploader :numberLimit="1" :file-list="formData.pics" />
              </a-form-item>
            </a-col>
          </a-row>

          <!-- <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="上传视频"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="need_video"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="需要"
                  unCheckedChildren="不需要"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="信息审核"
                extra="省市修改信息后需要CCA审核"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="need_shenhe"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="需要"
                  unCheckedChildren="不需要"
                />
              </a-form-item>
            </a-col>
          </a-row> -->

          <!-- <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图片服务"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="photo_service"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="直播URL"
                hasFeedback
              >
                <a-input
                  v-decorator="['zhibo_url', { rules: [] }]"
                  placeholder="请输入直播URL"
                />
              </a-form-item>
            </a-col>
          </a-row> -->
          <!-- <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="直播二维码"
                hasFeedback
              >
                <pic-uploader
                  :numberLimit="4"
                  :file-list="formData.zhibo_pic"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                 :labelCol="labelCol"
                 :wrapperCol="wrapperCol"
                 label="报名须知"
                 hasFeedback
           > 
                <a-textarea   v-decorator="[
              'notice',
              {rules: []}
            ]"
                          placeholder="请输入报名须知"/>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                v-if="false"
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="替补运动员限制人数"
                hasFeedback
              >
                <a-input
                  v-decorator="['tbydylimit', { rules: [] }]"
                  placeholder="请输入替补运动员限制人数"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row v-show="formData.photo_service == 1" :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图片价格(单张)"
                hasFeedback
              >
                <a-input
                  v-decorator="['photo_service_price', { rules: [] }]"
                  placeholder="请输入金额"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="图片价格(整站)"
                hasFeedback
              >
                <a-input
                  v-decorator="['photo_service_allprice', { rules: [] }]"
                  placeholder="请输入金额"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="奖项模式"
                hasFeedback
                :extra="
                  formData.prize_mod == 'rank'
                    ? '前八显示名次，八后显示优胜奖'
                    : '默认为前30%特等奖，前60%一等奖，其他二等奖。如需调整比例和奖项名称请在奖项规则中配置，仅支持三种奖项。'
                "
              >
                <a-radio-group v-model="formData.prize_mod" buttonStyle="solid">
                  <a-radio-button value="rank">普通模式</a-radio-button>
                  <a-radio-button value="fixed">等奖模式</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="是否集赞模式"
                hasFeedback 
              >
                <a-radio-group v-model="formData.is_jizan" buttonStyle="solid">
                  <a-radio-button :value="1">按集赞数评奖</a-radio-button>
                  <a-radio-button :value="2">按比赛得分评奖</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="奖项规则"
                v-show="formData.prize_mod == 'fixed'"
                hasFeedback
              >
                <a-textarea
                  autosize
                  v-decorator="['prize_rule', { rules: [] }]"
                  placeholder="30=特等奖
60=一等奖
二等奖"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="费用模式"
                hasFeedback
                :extra="
                  formData.price_mod == '1'
                    ? '按人收费，俱乐部/公开组别兼报项目分别收费'
                    : '按每人每项收费'
                "
              >
                <a-radio-group v-model="formData.price_mod" buttonStyle="solid">
                  <a-radio-button :value="1">按人收费</a-radio-button>
                  <a-radio-button :value="2">按项收费</a-radio-button>
                </a-radio-group>
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="限报数量"
                extra="一个人限制报名的项目数量"
                hasFeedback
              >
                <a-input
                  v-decorator="['memberlimitsubject', { rules: [] }]"
                  placeholder="请输入限报数量"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="成绩查询"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="show_result"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="证书下载"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="show_cert"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="教练证书"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="show_jlcert"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="裁判证书"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="show_cpcert"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="优秀教练员申报"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="can_youxiu"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="开启信息核对"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="xinxihedui_open"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="赛事模式"
                hasFeedback
              >
                <a-radio-group v-model="formData.is_online" buttonStyle="solid">
                  <a-radio-button :value="1">线上</a-radio-button>
                  <a-radio-button :value="2">线下</a-radio-button>
                  <a-radio-button :value="3">线上线下结合</a-radio-button>
                </a-radio-group> 
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="线上开票"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="can_kaipiao"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="强制安排食宿"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="forcehotel"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="本地队伍食宿"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="localhotel"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="不强制"
                  unCheckedChildren="强制安排"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="调查问卷URL"
                hasFeedback
              >
                <a-input
                  v-decorator="['wenjuanxing_url', { rules: [] }]"
                  placeholder="请输入调查问卷URL"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="承办方总成本"
                hasFeedback
              >
                <a-input
                  v-decorator="['undertake_cost', { rules: [] }]"
                  placeholder="请输入承办方总成本"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="承办方类型"
                hasFeedback
              >
                <a-select
                  v-model="formData.undertake_type"
                  placeholder="请选择承办方类型"
                  allowClear
                >
                  <a-select-option :value="1">省级</a-select-option>
                  <a-select-option :value="2">市级</a-select-option>
                  <a-select-option :value="3">其他</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="是否安排接送站"
                hasFeedback
              >
                <r-switch
                  :formData="formData"
                  field="is_jiesong"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="开启"
                  unCheckedChildren="关闭"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>成绩单成绩册 logo和签名</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="Logo"
                hasFeedback
              >
                <pic-uploader
                  :numberLimit="1"
                  :file-list="formData.score_logo"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="签名"
                hasFeedback
              >
                <pic-uploader
                  :numberLimit="1"
                  :file-list="formData.score_sign"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>主承协单位</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="主办"
                hasFeedback
              >
                <a-textarea
                  v-model="formData.zban"
                  placeholder="主办单位"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="承办"
                hasFeedback
              >
                <a-textarea
                  v-model="formData.cban"
                  placeholder="承办单位"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="协办"
                hasFeedback
              >
                <a-textarea
                  v-model="formData.xban"
                  placeholder="协办单位"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>秩序册素材</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="秩序册素材1"
                extra="封面,总局规程页,通知及竞赛规程,组委会名单,日程表,场地图"
                hasFeedback
              >
                <file-uploader
                  :numberLimit="1"
                  accept=".docx"
                  :file-list="formData.pic1"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :numberLimit="10"
                label="秩序册素材2"
                extra="广告页,底图"
                hasFeedback
              >
                <file-uploader
                  :numberLimit="1"
                  accept=".docx"
                  :file-list="formData.pic2"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>PDF文件</a-divider>

          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="成绩册PDF文件"
                hasFeedback
              >
                <file-uploader
                  :numberLimit="1"
                  accept=".pdf"
                  :file-list="formData.score_pdf_url"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :numberLimit="10"
                label="秩序册PDF文件"
                hasFeedback
              >
                <file-uploader
                  :numberLimit="1"
                  accept=".pdf"
                  :file-list="formData.zhixuce_pdf_url"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-divider>投票设置</a-divider>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="场地介绍"
                hasFeedback
              >
                <a-textarea
                  v-model="formData.changdijieshao"
                  placeholder="场地介绍"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :numberLimit="10"
                label="赛区介绍"
                hasFeedback
              >
                <a-textarea
                  v-model="formData.saiqujieshao"
                  placeholder="赛区介绍"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="人气奖励"
                hasFeedback
              >
                <a-textarea
                  v-model="formData.renqijiangli"
                  placeholder="人气奖励"
                  :auto-size="{ minRows: 3, maxRows: 5 }"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                :numberLimit="1"
                label="投票视频"
                hasFeedback
              >
                <video-uploader
                  :numberLimit="1"
                  accept=".mov,.mp4"
                  :file-list="formData.toupiaovideo"
                />
              </a-form-item>
            </a-col>
          </a-row> -->
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleOk"
          >保存</a-button
        >
      </template>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="相关文件操作"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="documentVisible"
      @ok="documentVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">
          <a-table
            :columns="documentColumns"
            :dataSource="documentList"
            :pagination="false"
            rowKey="id"
            :scroll="{ y: 300 }"
            bordered
          >
            <span slot="name" slot-scope="name, record">
              <!--              <img :src="record.face" style="width: 40px; vertical-align: middle;" /> -->
              {{ record.title }}
            </span>
            <span slot="typename" slot-scope="name, record">
              <em v-if="record.type == 1">
                通知文件
              </em>
              <em v-else-if="record.type == 2">
                日程表
              </em>
              <em v-else-if="record.type == 3">
                食宿安排
              </em>
            </span>
            <template slot="action" slot-scope="text, record, index">
              <!--              <a-divider type="vertical" />-->
              <a-popconfirm
                title="确定删除该文章吗"
                @confirm="deleteFile(record, index)"
                okText="确定"
                cancelText="取消"
              >
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <content-picker
                style="width: 500px; margin-right: 10px;"
                :formData="fileFormData"
                field="content_id"
              />
              <a-select
                style="width: 200px; margin-right: 10px;"
                v-model="fileFormData.type"
                placeholder="类型"
              >
                <a-select-option value="1">通知文件</a-select-option>
                <a-select-option value="2">日程表</a-select-option>
                <a-select-option value="3">食宿安排</a-select-option>
              </a-select>
              <a-button icon="plus" @click="addFile">新增</a-button>
            </template>
          </a-table>
        </a-form>
      </a-spin>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="房型设置"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="roomTypeVisible"
      @ok="roomTypeVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
          :columns="roomTypeColumns"
          :dataSource="roomTypeList"
          :pagination="false"
          rowKey="id"
          :scroll="{ y: 300 }"
          bordered
        >
          <span slot="show" slot-scope="text, record">
            <a-tag v-if="record.show == 1" color="green">显示</a-tag>
            <a-tag v-else>隐藏</a-tag>
          </span>
          <template slot="action" slot-scope="text, record, index">
            <a href="javascript:;" @click="onEditRoomType(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="确定删除吗"
              @confirm="deleteRoomType(record, index)"
              okText="确定"
              cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
          <template slot="footer" slot-scope="currentPageData">
            <a-button icon="plus" @click="onAddRoomType">新增</a-button>
          </template>
        </a-table>
      </a-spin>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="食宿配置"
      :width="1000"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="roomTypeFormVisible"
      @ok="handleRoomTypeOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form2">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="名称"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'name',
                    { rules: [{ required: true, message: '请输入套餐名称' }] },
                  ]"
                  placeholder="请输入名称"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="限住人数"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'limit',
                    { rules: [{ required: true, message: '请输入限住人数' }] },
                  ]"
                  placeholder="请输入限住人数"
                />
              </a-form-item>
            </a-col>
          </a-row>
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="单价"
                extra="按照房间总价格填写"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'price',
                    { rules: [{ required: true, message: '请输入单价' }] },
                  ]"
                  placeholder="请输入单价"
                />
              </a-form-item>
            </a-col>

            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="是否显示"
                hasFeedback
              >
                <r-switch
                  :formData="roomTypeFormData"
                  field="show"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="是"
                  unCheckedChildren="否"
                />
              </a-form-item>
            </a-col>
          </a-row>

          <a-row :gutter="48"> 
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="仅幼儿单位可见"
                hasFeedback
              >
                <r-switch
                  :formData="roomTypeFormData"
                  field="show_youer"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="是"
                  unCheckedChildren="否"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="仅后台可编辑"
                extra="用于随行人员补缴食宿费"
                hasFeedback
              >
                <r-switch
                  :formData="roomTypeFormData"
                  field="edit_admin"
                  :checkedValue="1"
                  :unCheckedValue="2"
                  checkedChildren="是"
                  unCheckedChildren="否"
                />
              </a-form-item>
            </a-col>
          </a-row>

        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleRoomTypeCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleRoomTypeOk"
          >保存</a-button
        >
      </template>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="车站机场设置"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="stationVisible"
      @ok="stationVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
          :columns="stationColumns"
          :dataSource="stationList"
          :pagination="false"
          rowKey="id"
          :scroll="{ y: 300 }"
          bordered
        >
          <template slot="action" slot-scope="text, record, index">
            <a href="javascript:;" @click="onEditStation(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="确定删除吗"
              @confirm="deleteStation(record, index)"
              okText="确定"
              cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
          <template slot="footer" slot-scope="currentPageData">
            <a-button icon="plus" @click="onAddStation">新增</a-button>
          </template>
        </a-table>
      </a-spin>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="车站机场配置"
      :width="1000"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="stationFormVisible"
      @ok="handleStationOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form5">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="名称"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'name',
                    {
                      rules: [
                        { required: true, message: '请输入车站机场名称' },
                      ],
                    },
                  ]"
                  placeholder="请输入车站机场名称"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="地址"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'address',
                    { rules: [] },
                  ]"
                  placeholder="请输入地址"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleStationCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleStationOk"
          >保存</a-button
        >
      </template>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="执行官设置"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="zhixingguanVisible"
      @ok="zhixingguanVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
          :columns="zhixingguanColumns"
          :dataSource="zhixingguanList"
          :pagination="false"
          rowKey="id"
          :scroll="{ y: 300 }"
          bordered
        >
          <template slot="action" slot-scope="text, record, index">
            <a href="javascript:;" @click="onEditZhixingguan(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="确定删除吗"
              @confirm="deleteZhixingguan(record, index)"
              okText="确定"
              cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
          <template slot="footer" slot-scope="currentPageData">
            <a-button icon="plus" @click="onAddZhixingguan">新增</a-button>
          </template>
        </a-table>
      </a-spin>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="执行官配置"
      :width="1000"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="zhixingguanFormVisible"
      @ok="handleZhixingguanOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form6">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="姓名"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'name',
                    { rules: [{ required: true, message: '请输入姓名' }] },
                  ]"
                  placeholder="请输入姓名"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="身份证"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'num',
                    { rules: [{ required: true, message: '请输入身份证号' }] },
                  ]"
                  placeholder="请输入身份证号"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleZhixingguanCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleZhixingguanOk"
          >保存</a-button
        >
      </template>
    </a-modal>

    <!-- cca负责人 -->
    <a-modal
      :maskClosable="false"
      title="负责人设置"
      :width="1000"
      style="top: 20px;"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="ccarenVisible"
      @ok="ccarenVisible = false"
    >
      <a-spin :spinning="saveLoading">
        <a-table
          :columns="ccarenColumns"
          :dataSource="ccarenList"
          :pagination="false"
          rowKey="id"
          :scroll="{ y: 300 }"
          bordered
        >
          <template slot="action" slot-scope="text, record, index">
            <a href="javascript:;" @click="onEditCcaren(record)">编辑</a>
            <a-divider type="vertical" />
            <a-popconfirm
              title="确定删除吗"
              @confirm="deleteCcaren(record, index)"
              okText="确定"
              cancelText="取消"
            >
              <a href="javascript:;">删除</a>
            </a-popconfirm>
          </template>
          <template slot="footer" slot-scope="currentPageData">
            <a-button icon="plus" @click="onAddCcaren">新增</a-button>
          </template>
        </a-table>
      </a-spin>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="负责人配置"
      :width="1000"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="ccarenFormVisible"
      @ok="handleCcarenOk"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form7">
          <a-row :gutter="48">
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="姓名"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'name',
                    { rules: [{ required: true, message: '请输入姓名' }] },
                  ]"
                  placeholder="请输入姓名"
                />
              </a-form-item>
            </a-col>
            <a-col :md="12" :sm="24">
              <a-form-item
                :labelCol="labelCol"
                :wrapperCol="wrapperCol"
                label="身份证"
                hasFeedback
              >
                <a-input
                  v-decorator="[
                    'num',
                    { rules: [{ required: true, message: '请输入身份证号' }] },
                  ]"
                  placeholder="请输入身份证号"
                />
              </a-form-item>
            </a-col>
          </a-row>
        </a-form>
      </a-spin>
      <template slot="footer">
        <a-button key="cancel" @click="handleCcarenCancel">取消</a-button>
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleCcarenOk"
          >保存</a-button
        >
      </template>
    </a-modal>


    <a-modal
        :maskClosable="false"
            title="赛区合伙人"
            :width="800"
            v-model="userListVisible"
            @ok="userListVisible=false"
    >
      <a-spin :spinning="saveLoading">
        <a-form :form="form">

          <a-table :columns="userColumns" :dataSource="adminUserList"   rowKey="id" :scroll="{ y: 300 }" bordered>
            <span slot="name" slot-scope="name,record">
              <img :src="record.face" style="width: 40px; vertical-align: middle;" /> {{record.name}} ({{record.phone}})
            </span> 
            <template slot="action" slot-scope="text,record,index">
              <a-divider type="vertical" />
              <a-popconfirm title="确定删除此人员吗" @confirm="deleteUser(record,index)"  okText="确定" cancelText="取消">
                <a href="javascript:;">删除</a>
              </a-popconfirm>
            </template>
            <template slot="footer" slot-scope="currentPageData">
              <user-picker style="width: 200px; margin-right: 10px;" :formData="userFormData" field="user_id" />
              <a-button icon="plus" @click="addUser" >新增</a-button>
            </template>
          </a-table>
        </a-form>

      </a-spin>
    </a-modal>



    <!-- 投票分享 -->
    <a-modal
      :maskClosable="false"
      title="投票分享"
      :width="400"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="miniCodeVisible"
      @ok="handleminiCodeOk"
    >
      <img :src="MiniCode" alt="" class="MiniCode"/>
      <template slot="footer">
        <a-button
          key="forward"
          :loading="saveLoading"
          type="primary"
          @click="handleminiCodeOk"
          >关闭</a-button
        >
      </template>
    </a-modal>

    <a-modal
      :maskClosable="false"
      title="点击统计"
      :width="400"
      :bodyStyle="{ maxHeight: '500px', overflowY: 'scroll' }"
      v-model="visitVisible" 
    > 
    <p :key="vi" v-for="(vv,vi) in visitData">
      <span v-if="vv.type=='tongzhiwenjian'">通知文件:</span>
      <span v-if="vv.type=='richengbiao'">日程表:</span>
      <span v-if="vv.type=='xinxihedui'">信息核对:</span>
      <span v-if="vv.type=='shisuanpai'">食宿安排:</span>
      <span v-if="vv.type=='chengjichaxun'">成绩查询:</span>
      <span v-if="vv.type=='chengjicexiazai'">成绩下载:</span>
      <span v-if="vv.type=='diaocha'">调查问卷:</span>
      <span v-if="vv.type=='zhibo'">直播:</span>
      <span>{{vv.count}}</span>

    </p>
    </a-modal>

    
  </a-card>
</template>

<script>
  import setting from '@/config/setting'
import STable from "@/components/table/";
import ATextarea from "ant-design-vue/es/input/TextArea";
import AInput from "ant-design-vue/es/input/Input";
import EditableCell from "@/components/EditableCell/";
import PicUploader from "@/components/PicUploader/";
import FileUploader from "@/components/FileUploader/";
import VideoUploader from "@/components/VideoUploader/";
import RSwitch from "@/components/RSwitch/";
import ContentPicker from "@/components/ContentPicker/";
import areaOptions from "@/utils/area";
import UserPicker from "@/components/UserPicker/";
import moment from "moment";
import "moment/locale/zh-cn";

moment.locale("zh-cn");

import {
  getSaiquList,
  getSaiquDetail,
  editSaiqu,
  addSaiqu,
  deleteSaiqu,
  getSaijiList,
  getSubjectTypeOptions,
  addSaiFile,
  deleteSaiFile,
  getSaiFileList,
  getRoomTypeList,
  roomTypeDelete,
  getRoomTypeDetail,
  editRoomType,
  addRoomType,
  getHotelList,
  hotelDelete,
  getVisitData,
  getHotelDetail,
  editHotel,
  addHotel,
  getBusList,
  busDelete,
  getBusDetail,
  editBus,
  addBus,
  getStationList,
  stationDelete,
  getStationDetail,
  editStation,
  addStation,
  getZhixingguanList,
  zhixingguanDelete,
  getZhixingguanDetail,
  editZhixingguan,
  addZhixingguan,
  getCcarenList,
  getMiniCode,
  ccarenDelete,
  getCcarenDetail,
  editCcaren,
  addCcaren,
  deleteAdminUser,
  getAdminUserList,
  addAdminUser, 
  setSaiquThird, 
} from "@/api/sai";
import { deleteGuafen } from "@/api/guafen";

export default {
  name: "KaojiSaiquList",
  components: {
    AInput,
    ATextarea,
    FileUploader,
    PicUploader,
    STable,
    RSwitch,
    EditableCell,
    ContentPicker,
    UserPicker,
    VideoUploader,
  },
  data() {
    return {
      areaOptions,
      MiniCode: "",
      userListVisible:false,
      visible: false,
      applyVisible: false,
      documentVisible: false,
      saveLoading: false,
      subjectTypeOptions: [],
      mainUnitShow: false,
      holdUnitShow: false,
      helpUnitShow: false,
      unitName: "",
      holdUnitName: "",
      helpUnitName: "",
      formData: {
        id: 0,
        status: 1,
        level: 1,
        project_type:'',
        photo_service: 1,
        need_video: 1,
        need_shenhe: 1,
        mingcheng_end: "",
        xinxihedui_open: 1,
        type: 1,
        stype: "",
        undertake_type: "",
        is_jiesong: "",
        undertake_cost: 0,
        danwei: "",
        saidate_moment: [],
        saidate: [],
        time_range_moment: [],
        time_range: [],
        erweiimg: [],
        erweiimg2: [],
        erweiimg3: [],
        pay_pic: [],
        third_pay_info: "",
        areas: [],
        pic: [],
        pics: [],
        pic1: [],
        pic2: [],
        pic3: [],
        pic4: [],
        pic5: [],
        pic6: [],
        pic7: [],
        pic8: [],
        score_pdf_url: [],
        zhixuce_pdf_url: [],
        changdijieshao: "",
        saiqujieshao: "",
        renqijiangli: "",
        toupiaovideo: [],
        zhibo_pic: [],
        notice: '',
        is_online:0,
        tbydylimit: "",
        memberlimitsubject: "",
        zban: "国家体育总局体操运动管理中心\n中国蹦床与技巧协会\n",
        cban: "中国蹦床与技巧协会啦啦操分会\n南京新恒鼎体育推广有限公司\n",
        xban: "南京合生汇信息科技有限公司\n",
        score_sign: [],
        score_logo: [],
      },
      saijiOptions: [],
      labelCol: {
        //          xs: { span: 24 },
        //          sm: { span: 5 },
        xs: { span: 24 },
        sm: { span: 8 },
      },
      wrapperCol: {
        xs: { span: 24 },
        sm: { span: 12 },
      },
      form: this.$form.createForm(this),
      form2: this.$form.createForm(this),
      form3: this.$form.createForm(this),
      form4: this.$form.createForm(this),
      form5: this.$form.createForm(this),
      form6: this.$form.createForm(this),
      form7: this.$form.createForm(this),
      mdl: {},

      // 高级搜索 展开/关闭
      advanced: false,
      // 查询参数
      queryParam: {
        keywords: "",
      },
      // 表头
      columns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "名称",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        },
        {
          title: "状态",
          dataIndex: "status",
          scopedSlots: { customRender: "status" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 200,
          scopedSlots: { customRender: "action" },
        },
      ],
      // 加载数据方法 必须为 Promise 对象
      loadData: (parameter) => {
        console.log("loadData");
        console.log(this.queryParam);
        let that = this;

        this.queryParam = Object.assign(this.queryParam, parameter);
        return getSaiquList(this.queryParam).then((res) => {
          console.log("res");
          return res.data;
        });
      },

      selectedRowKeys: [],
      selectedRows: [],
      cashFormData: {
        ids: [],
        to_type: "",
        price: 0,
        note: "",
        count: 0,
      },
      fileFormData: {
        saiqu: undefined,
        content_id: undefined,
      },
      userFormData: {
        user_id: undefined,
        saiqu: undefined,
      },
      //人员管理表头
      userColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "80px",
        },
        {
          title: "用户名",
          dataIndex: "name",
          scopedSlots: { customRender: "name" },
        }, 
        {
          title: "操作",
          dataIndex: "action",
          width: "150px",
          scopedSlots: { customRender: "action" },
        },
      ],
      adminUserList: [],
      //人员管理表头
      documentColumns: [
        {
          title: "#",
          dataIndex: "id",
          width: "50px",
        },
        {
          title: "标题",
          dataIndex: "title",
          scopedSlots: { customRender: "name" },
        } /*
                 {
                 title: '角色',
                 width:'100px',
                 dataIndex: 'role_type',
                 },*/,

        {
          title: "类型",
          width: "100px",
          dataIndex: "type",
          scopedSlots: { customRender: "typename" },
          filters: [
            {
              text: "通知文件",
              value: "1",
            },
            {
              text: "日程表",
              value: "2",
            },
            {
              text: "食宿安排",
              value: "3",
            },
          ],
          filterMultiple: false,
          onFilter: (value, record) => record.type == value,
        },
        {
          title: "操作",
          dataIndex: "action",
          width: "150px",
          scopedSlots: { customRender: "action" },
        },
      ],
      documentList: [],
      documentKeywords: "",

      roomTypeQuery: {
        saiqu: 0,
      },
      roomTypeVisible: false,
      roomTypeFormVisible: false,
      roomTypeList: [],
      roomTypeFormData: {
        id: 0,
        name: "",
        limit: "",
        price: "",
        show: 1,
        show_youer: 2,
        edit_admin: 2,
      },

      //表头
      roomTypeColumns: [
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "价格",
          width: "150px",
          dataIndex: "price",
        },
        {
          title: "限住人数",
          width: "150px",
          dataIndex: "limit",
        },
        {
          title: "显示",
          dataIndex: "show",
          width: "150px",
          scopedSlots: { customRender: "show" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 150,
          scopedSlots: { customRender: "action" },
        },
      ],

      //酒店
      hotelQuery: {
        saiqu: 0,
      },
      hotelVisible: false,
      hotelFormVisible: false,
      hotelList: [],
      hotelFormData: {
        id: 0,
        level: "",
      },

      //表头
      hotelColumns: [
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "地址",
          width: "150px",
          dataIndex: "address",
        },
        {
          title: "联系",
          width: "150px",
          dataIndex: "lianxi",
          scopedSlots: { customRender: "lianxi" },
        },
        {
          title: "等级",
          dataIndex: "level",
          width: "150px",
          scopedSlots: { customRender: "level" },
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 150,
          scopedSlots: { customRender: "action" },
        },
      ],

      //交通
      busQuery: {
        saiqu: 0,
      },
      busVisible: false,
      busFormVisible: false,
      busList: [],
      busFormData: {
        id: 0,
        level: "",
      },

      //表头
      busColumns: [
        {
          title: "车型",
          dataIndex: "name",
        },
        {
          title: "座位数",
          width: "150px",
          dataIndex: "limit",
        },
        {
          title: "价格",
          width: "150px",
          dataIndex: "price",
        },
        {
          title: "数量",
          dataIndex: "number",
          width: "150px",
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 150,
          scopedSlots: { customRender: "action" },
        },
      ],

      //车站
      stationQuery: {
        saiqu: 0,
      },
      stationVisible: false,
      stationFormVisible: false,
      stationList: [],
      stationFormData: {
        id: 0,
        level: "",
      },

      //表头
      stationColumns: [
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "地址",
          width: "250px",
          dataIndex: "address",
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 150,
          scopedSlots: { customRender: "action" },
        },
      ],

      //执行官

      zhixingguanQuery: {
        saiqu: 0,
      },
      zhixingguanVisible: false,
      zhixingguanFormVisible: false,
      zhixingguanList: [],
      zhixingguanFormData: {
        id: 0,
        level: "",
      },

      //表头
      zhixingguanColumns: [
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "身份证",
          width: "250px",
          dataIndex: "num",
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 150,
          scopedSlots: { customRender: "action" },
        },
      ],

      //cca负责人

      ccarenQuery: {
        saiqu: 0,
      },
      ccarenVisible: false,
      miniCodeVisible: false,
      ccarenFormVisible: false,
      visitVisible: false,
      visitData:{

      },
      ccarenList: [],
      ccarenFormData: {
        id: 0,
        level: "",
      },

      //表头
      ccarenColumns: [
        {
          title: "名称",
          dataIndex: "name",
        },
        {
          title: "身份证",
          width: "250px",
          dataIndex: "num",
        },
        {
          title: "操作",
          dataIndex: "action",
          fixed: "right",
          width: 150,
          scopedSlots: { customRender: "action" },
        },
      ],
    };
  },
  computed: {},
  created() {},

  mounted() {
    let that = this;
    that.getSaijiOptions();
    that.getSubjectTypeOptions();
  },
  methods: {
    moment,
    addHandle() {
      this.formData = {
        id: 0,
        status: 1,
        project_type:'',
        level: 1,
        photo_service: 2,
        show_result: 2,
        show_cert: 2,
        show_jlcert: 2,
        show_cpcert: 2,
        can_youxiu: 2,
        xinxihedui_open: 1,
        mingcheng_end: "队",
        is_online: 2,
        forcehotel: 2,
        localhotel: 1,
        can_kaipiao: 2,
        prize_mod: "rank",
        is_jizan: 2,
        need_shenhe: 1,
        need_video: 1,
        type: 1,
        stype: "",
        undertake_type: "",
        is_jiesong: "",
        undertake_cost: 0,
        price_mod: 1,
        saidate_moment: [],
        saidate: [],
        zhibo_pic: [],
        notice: '',
        time_range_moment: [],
        time_range: [],
        erweiimg: [],
        erweiimg2: [],
        erweiimg3: [],
        pay_pic: [],
        third_pay_info: "",
        areas: [],
        pic: [],
        pics: [],
        pic1: [],
        pic2: [],
        pic3: [],
        pic4: [],
        pic5: [],
        pic6: [],
        pic7: [],
        pic8: [],
        score_pdf_url: [],
        zhixuce_pdf_url: [],
        changdijieshao: "",
        saiqujieshao: "",
        renqijiangli: "",
        toupiaovideo: [],
        zban: "国家体育总局体操运动管理中心\n中国蹦床与技巧协会\n",
        cban: "中国蹦床与技巧协会啦啦操分会\n南京新恒鼎体育推广有限公司\n",
        xban: "南京合生汇信息科技有限公司\n",
        score_sign: [],
        score_logo: [{
          save_name:'logo2.png',
          name:'logo2.png',
          uid:0,
          url:'https://ccago.oss-cn-hangzhou.aliyuncs.com/editor/20220424/user-0/20220424/8b188c1f662d7086709026dfcdcf8087.png'
        }],
      },
        this.form.resetFields();
      this.visible = true;
    },
    handleCancel() {
      this.visible = false;
    },
    getSaijiOptions() {
      let that = this;
      getSaijiList().then((res) => {
        that.saijiOptions = res.data.list;
      });
    },
    getSubjectTypeOptions() {
      let that = this;
      getSubjectTypeOptions().then((res) => {
        that.subjectTypeOptions = res.data;
      });
    },
    //展开关闭
    toggleAdvanced() {
      this.advanced = !this.advanced;
    },
    handleDate(record) {
      const { href } = this.$router.resolve({
        name: "SaiDateDetail",
        query: { id: record.id },
      });
      window.open(href, "_blank");
    },
    handleEdit(record) {
      let self = this;
      this.visible = true;
      getSaiquDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form.setFieldsValue({ ...res.data });
          self.formData.id = record.id;
          console.log("handleEdit");
          if (res.data.area) {
            res.data.areas = [
              res.data.area.substring(0, 2) + "0000",
              res.data.area.substring(0, 4) + "00",
              res.data.area,
            ];
          } else {
            res.data.areas = [];
          }
          res.data.saidate_moment = [
            moment(res.data.saidate * 1000),
            moment(res.data.saidate_end * 1000),
          ]; //moment(res.data.saidate*1000);
          res.data.time_range_moment = [
            moment(res.data.stime * 1000),
            moment(res.data.etime * 1000),
          ];
          self.formData = { ...res.data };
        }, 200);
      });
      // console.log(this.mdl)
    },

    deleteHandle(record) {
      let self = this;
      deleteSaiqu({ id: record.id })
        .then((res) => {
          self.$message.success("删除成功");
          self.$refs.table.refresh(false);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    // 查
    onSearch() {
      let self = this;
      self.$refs.table.refresh(false);
    },

    // 增改 处理
    handleOk(e) {
      let self = this;
      e.preventDefault();
      if (self.formData.time_range_moment.length != 2) {
        self.$message.error("请选择时间范围");
        return;
      }
      if (!self.formData.project_type) {
        self.$message.error("请选择赛事类型");
        return;
      }
      if (!self.formData.subjecttype) {
        self.$message.error("请选择项目配置");
        return;
      }
      if (!self.formData.saiji) {
        self.$message.error("请选择赛季");
        return;
      }
      if (self.formData.areas.length != 3) {
        self.$message.error("请选择完整地区");
        return;
      }
      if (self.formData.saidate_moment.length != 2) {
        self.$message.error("请选择比赛时间");
        return;
      }
      this.form.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.formData);
          self.saveLoading = true;
          if (self.formData.id > 0) {
            editSaiqu({
              id: self.formData.id,
              name: values.name,
              saiji: self.formData.saiji,
              photo_service: self.formData.photo_service,
              level: self.formData.level,
              need_shenhe: self.formData.need_shenhe,
              need_video: self.formData.need_video,
              subjecttype: self.formData.subjecttype,
              project_type: self.formData.project_type,
              status: self.formData.status,
              type: self.formData.type,
              stype: self.formData.stype,
              area: self.formData.areas[self.formData.areas.length - 1],
              saidate: [
                self.formData.saidate_moment[0].format("YYYY-MM-DD"),
                self.formData.saidate_moment[1].format("YYYY-MM-DD"),
              ], //self.formData.saidate_moment.format('YYYY-MM-DD'),
              time_range: [
                self.formData.time_range_moment[0].format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
                self.formData.time_range_moment[1].format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
              ],
              memberoneprice: values.memberoneprice,
              photo_service_price: values.photo_service_price,
              photo_service_allprice: values.photo_service_allprice,
              zhibo_url: values.zhibo_url,
              wenjuanxing_url: values.wenjuanxing_url,
              erweiimg: self.formData.erweiimg,
              erweiimg2: self.formData.erweiimg2,
              erweiimg3: self.formData.erweiimg3,
              pay_pic: self.formData.pay_pic,
              third_pay_info: self.formData.third_pay_info,
              pic: self.formData.pic,
              pic1: self.formData.pic1,
              pic2: self.formData.pic2,
              pic3: self.formData.pic3,
              pic4: self.formData.pic4,
              pic5: self.formData.pic5,
              pic6: self.formData.pic6,
              pic7: self.formData.pic7,
              pic8: self.formData.pic8,
              score_pdf_url: self.formData.score_pdf_url,
              zhixuce_pdf_url: self.formData.zhixuce_pdf_url,
              changdijieshao: self.formData.changdijieshao,
              saiqujieshao: self.formData.saiqujieshao,
              renqijiangli: self.formData.renqijiangli,
              toupiaovideo: self.formData.toupiaovideo,
              zhibo_pic: self.formData.zhibo_pic,
              zban: self.formData.zban,
              cban: self.formData.cban,
              xban: self.formData.xban,
              score_sign: self.formData.score_sign,
              score_logo: self.formData.score_logo,
              pics: self.formData.pics,
              show_result: self.formData.show_result,
              show_cert: self.formData.show_cert,
              show_jlcert: self.formData.show_jlcert,
              show_cpcert: self.formData.show_cpcert,
              can_youxiu: self.formData.can_youxiu,
              xinxihedui_open: self.formData.xinxihedui_open,
              mingcheng_end: self.formData.mingcheng_end,
              localhotel: self.formData.localhotel,
              forcehotel: self.formData.forcehotel,
              is_online: self.formData.is_online,
              can_kaipiao: self.formData.can_kaipiao,
              prize_mod: self.formData.prize_mod,
              price_mod: self.formData.price_mod,
              is_jizan: self.formData.is_jizan,
              prize_rule: values.prize_rule,
              notice: values.notice,
              fuzeren: values.fuzeren,
              zixunren: values.zixunren,
              undertake_type: self.formData.undertake_type,
              is_jiesong: self.formData.is_jiesong,
              undertake_cost: values.undertake_cost,
              tbydylimit: values.tbydylimit,
              memberlimitsubject: values.memberlimitsubject,
            })
              .then((res) => {
                self.$message.success("修改成功");
                self.$refs.table.refresh(false);
                self.visible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          } else {
            addSaiqu({
              name: values.name,
              saiji: self.formData.saiji,
              subjecttype: self.formData.subjecttype,
              photo_service: self.formData.photo_service,
              level: self.formData.level,
              need_shenhe: self.formData.need_shenhe,
              project_type: self.formData.project_type,
              need_video: self.formData.need_video,
              localhotel: self.formData.localhotel,
              forcehotel: self.formData.forcehotel,
              status: self.formData.status,
              can_kaipiao: self.formData.can_kaipiao,
              type: self.formData.type,
              stype: self.formData.stype,
              area: self.formData.areas[self.formData.areas.length - 1],
              saidate: [
                self.formData.saidate_moment[0].format("YYYY-MM-DD"),
                self.formData.saidate_moment[1].format("YYYY-MM-DD"),
              ], //self.formData.saidate_moment.format('YYYY-MM-DD'),
              time_range: [
                self.formData.time_range_moment[0].format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
                self.formData.time_range_moment[1].format(
                  "YYYY-MM-DD HH:mm:ss"
                ),
              ],
              memberoneprice: values.memberoneprice,
              photo_service_price: values.photo_service_price,
              photo_service_allprice: values.photo_service_allprice,
              erweiimg: self.formData.erweiimg,
              erweiimg2: self.formData.erweiimg2,
              erweiimg3: self.formData.erweiimg3,
              pay_pic: self.formData.pay_pic,
              third_pay_info: self.formData.third_pay_info,
              pic: self.formData.pic,
              pic1: self.formData.pic1,
              pic2: self.formData.pic2,
              pic3: self.formData.pic3,
              pic4: self.formData.pic4,
              pic5: self.formData.pic5,
              pic6: self.formData.pic6,
              pic7: self.formData.pic7,
              pic8: self.formData.pic8,
              pics: self.formData.pics,
              score_pdf_url: self.formData.score_pdf_url,
              zhixuce_pdf_url: self.formData.zhixuce_pdf_url,
              changdijieshao: self.formData.changdijieshao,
              saiqujieshao: self.formData.saiqujieshao,
              renqijiangli: self.formData.renqijiangli,
              toupiaovideo: self.formData.toupiaovideo,
              zhibo_pic: self.formData.zhibo_pic,
              zban: self.formData.zban,
              cban: self.formData.cban,
              xban: self.formData.xban,
              score_sign: self.formData.score_sign,
              score_logo: self.formData.score_logo,
              zhibo_url: values.zhibo_url,
              wenjuanxing_url: values.wenjuanxing_url,
              show_result: self.formData.show_result,
              show_cert: self.formData.show_cert,
              show_jlcert: self.formData.show_jlcert,
              show_cpcert: self.formData.show_cpcert,
              can_youxiu: self.formData.can_youxiu,
              xinxihedui_open: self.formData.xinxihedui_open,
              mingcheng_end: self.formData.mingcheng_end,
              is_jiesong: self.formData.is_jiesong,
              is_online: self.formData.is_online,
              prize_mod: self.formData.prize_mod,
              price_mod: self.formData.price_mod,
              is_jizan: self.formData.is_jizan,
              prize_rule: values.prize_rule,
              notice: values.notice,
              fuzeren: values.fuzeren,
              zixunren: values.zixunren,
              tbydylimit: values.tbydylimit,
              memberlimitsubject: values.memberlimitsubject,
            })
              .then((res) => {
                self.$message.success("修改成功");
                self.$refs.table.refresh(false);
                self.visible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },

    // 操作单位
    onUnitSet(type) {
      switch (type) {
        case 1:
          this.mainUnitShow = true;
          break;
        case 2:
          this.holdUnitShow = true;
          break;
        case 3:
          this.helpUnitShow = true;
          break;
      }
    },
    thirdChange(val,row){
        console.log(val)
        let that = this;
        let title = ''
        if(val===1){
          title = '是否切换成第三方赛事？'
        }else{
          title = '是否切换成非第三方赛事？'
        } 
        this.$confirm({
          title: '确认操作',
          content: title,
          onOk() {
            setSaiquThird({
              id:row.id,
              is_third:val
            })
            that.$message.success("切换成功");
            row.is_third=val
          },
          onCancel() { 
          },
        }); 
    },

    // 新增单位
    onUnitAdd(type) {
      const that = this;

      console.log(that.formData.main_unit);
      switch (type) {
        case 1:
          that.formData.main_unit.push(that.unitName);
          that.mainUnitShow = false;
          that.unitName = "";
          break;

        case 2:
          that.formData.hold_unit.push(that.holdUnitName);
          that.holdUnitShow = false;
          that.holdUnitName = "";
          break;

        case 3:
          that.formData.help_unit.push(that.helpUnitName);
          that.helpUnitShow = false;
          that.helpUnitName = "";
          break;
      }
    },

    // 删除单位
    onUnitDelete(type, index) {
      const that = this;
      switch (type) {
        case 1:
          this.formData.main_unit.splice(index, 1);
          this.mainUnitShow = false;
          break;

        case 2:
          this.formData.hold_unit.splice(index, 1);
          this.holdUnitShow = true;
          break;

        case 3:
          this.formData.help_unit.splice(index, 1);
          this.helpUnitShow = true;
          break;
      }

      that.unitName = "";
    },

    handleDocument(record) {
      let self = this;
      self.fileFormData.saiqu = record.id;
      self.getDocumentList();

      this.documentVisible = true;
    },

    getDocumentList() {
      let self = this;
      getSaiFileList({ saiqu: self.fileFormData.saiqu }).then((res) => {
        self.documentList = res.data;
      });
    },

    addFile() {
      let self = this;
      if (!self.fileFormData.content_id) {
        self.$message.error("请选择文章");
        return;
      }
      if (!self.fileFormData.type) {
        self.$message.error("请选择类型");
        return;
      }
      addSaiFile(self.fileFormData)
        .then((res) => {
          self.getDocumentList();

          self.fileFormData.content_id = undefined;
          // self.fileFormData.saiqu = undefined;

          self.$message.success("新增成功");
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    deleteFile(record, index) {
      let self = this;
      deleteSaiFile({
        saiqu: self.fileFormData.saiqu,
        content_id: record.id,
        content_id: record.id,
      })
        .then((res) => {
          self.$message.success("删除成功");
          self.documentList.splice(index, 1);
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },

    onAddRoomType() {
      (this.roomTypeFormData = {
        id: 0,
        name: "",
        limit: "",
        price: "",
        show: 1,
        show_youer: 2,
        edit_admin: 2,
      }),
        this.form2.resetFields();
      this.roomTypeFormVisible = true;
    },

    handleRoomTypeCancel() {
      this.roomTypeFormVisible = false;
    },
    onEditRoomType(record) {
      let self = this;
      this.roomTypeFormVisible = true;
      getRoomTypeDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form2.setFieldsValue({ ...res.data });
          self.roomTypeFormData.id = record.id;
          self.roomTypeFormData = { ...res.data };
        }, 200);
      });
    },
    deleteRoomType(record) {
      let self = this;
      roomTypeDelete({ id: record.id }).then((res) => {
        self.fetchRoomTypeList();
      });
    },

    fetchRoomTypeList() {
      let self = this;
      getRoomTypeList(self.roomTypeQuery).then((res) => {
        self.roomTypeList = res.data;
      });
    },

    handleRoomType(record) {
      let self = this;
      self.fetchRoomTypeList();
      self.roomTypeQuery.saiqu = record.id;
      self.roomTypeVisible = true;
    },

    // 增改 处理
    handleRoomTypeOk(e) {
      let self = this;
      e.preventDefault();
      this.form2.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.roomTypeFormData);
          self.saveLoading = true;
          if (self.roomTypeFormData.id > 0) {
            editRoomType({
              id: self.roomTypeFormData.id,
              name: values.name,
              price: values.price,
              limit: values.limit,
              show: self.roomTypeFormData.show,
              show_youer: self.roomTypeFormData.show_youer,
              edit_admin: self.roomTypeFormData.edit_admin,
            })
              .then((res) => {
                self.$message.success("修改成功");

                self.fetchRoomTypeList();

                self.roomTypeFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          } else {
            addRoomType({
              name: values.name,
              price: values.price,
              note: values.note,
              saiqu: self.roomTypeQuery.saiqu,
              limit: values.limit,
              show: self.roomTypeFormData.show,
              show_youer: self.roomTypeFormData.show_youer,
              edit_admin: self.roomTypeFormData.edit_admin,
            })
              .then((res) => {
                self.$message.success("新增成功");
                self.fetchRoomTypeList();

                self.roomTypeFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },

    //酒店

    onAddHotel() {
      (this.hotelFormData = {
        id: 0,
        name: "",
        limit: "",
        price: "",
        show: 1,
      }),
        this.form2.resetFields();
      this.hotelFormVisible = true;
    },

    handleHotelCancel() {
      this.hotelFormVisible = false;
    },
    onEditHotel(record) {
      let self = this;
      this.hotelFormVisible = true;
      getHotelDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form3.setFieldsValue({ ...res.data });
          self.hotelFormData.id = record.id;
          self.hotelFormData = { ...res.data };
        }, 200);
      });
    },
    deleteHotel(record) {
      let self = this;
      hotelDelete({ id: record.id }).then((res) => {
        self.fetchHotelList();
      });
    },

    fetchHotelList() {
      let self = this;
      getHotelList(self.hotelQuery).then((res) => {
        self.hotelList = res.data;
      });
    },

    handleHotel(record) {
      let self = this;
      self.fetchHotelList();
      self.hotelQuery.saiqu = record.id;
      self.hotelVisible = true;
    },

    // 增改 处理
    handleHotelOk(e) {
      let self = this;

      if (!self.hotelFormData.level) {
        self.$message.error("请选择等级");
        return;
      }

      e.preventDefault();
      this.form3.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.hotelFormData);
          self.saveLoading = true;
          if (self.hotelFormData.id > 0) {
            editHotel({
              id: self.hotelFormData.id,
              name: values.name,
              address: values.address,
              contact_name: values.contact_name,
              contact_phone: values.contact_phone,
              level: self.hotelFormData.level,
            })
              .then((res) => {
                self.$message.success("修改成功");

                self.fetchHotelList();

                self.hotelFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          } else {
            addHotel({
              saiqu: self.hotelQuery.saiqu,
              name: values.name,
              address: values.address,
              contact_name: values.contact_name,
              contact_phone: values.contact_phone,
              level: self.hotelFormData.level,
            })
              .then((res) => {
                self.$message.success("新增成功");
                self.fetchHotelList();

                self.hotelFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },

    //交通

    onAddBus() {
      (this.busFormData = {
        id: 0,
        name: "",
        limit: "",
        price: "",
        show: 1,
      }),
        this.form2.resetFields();
      this.busFormVisible = true;
    },

    handleBusCancel() {
      this.busFormVisible = false;
    },
    onEditBus(record) {
      let self = this;
      this.busFormVisible = true;
      getBusDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form3.setFieldsValue({ ...res.data });
          self.busFormData.id = record.id;
          self.busFormData = { ...res.data };
        }, 200);
      });
    },
    deleteBus(record) {
      let self = this;
      busDelete({ id: record.id }).then((res) => {
        self.fetchBusList();
      });
    },

    fetchBusList() {
      let self = this;
      getBusList(self.busQuery).then((res) => {
        self.busList = res.data;
      });
    },

    handleBus(record) {
      let self = this;
      self.fetchBusList();
      self.busQuery.saiqu = record.id;
      self.busVisible = true;
    },

    // 增改 处理
    handleBusOk(e) {
      let self = this;

      e.preventDefault();
      this.form4.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.busFormData);
          self.saveLoading = true;
          if (self.busFormData.id > 0) {
            editBus({
              id: self.busFormData.id,
              name: values.name,
              price: values.price,
              limit: values.limit,
              number: values.number,
            })
              .then((res) => {
                self.$message.success("修改成功");

                self.fetchBusList();

                self.busFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          } else {
            addBus({
              saiqu: self.busQuery.saiqu,
              name: values.name,
              price: values.price,
              limit: values.limit,
              number: values.number,
            })
              .then((res) => {
                self.$message.success("新增成功");
                self.fetchBusList();

                self.busFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },

    //车站

    onAddStation() {
      (this.stationFormData = {
        id: 0,
        name: "",
        limit: "",
        price: "",
        show: 1,
      }),
        this.form2.resetFields();
      this.stationFormVisible = true;
    },

    handleStationCancel() {
      this.stationFormVisible = false;
    },
    onEditStation(record) {
      let self = this;
      this.stationFormVisible = true;
      getStationDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form5.setFieldsValue({ ...res.data });
          self.stationFormData.id = record.id;
          self.stationFormData = { ...res.data };
        }, 200);
      });
    },
    deleteStation(record) {
      let self = this;
      stationDelete({ id: record.id }).then((res) => {
        self.fetchStationList();
      });
    },

    fetchStationList() {
      let self = this;
      getStationList(self.stationQuery).then((res) => {
        self.stationList = res.data;
      });
    },

    handleStation(record) {
      let self = this;
      self.fetchStationList();
      self.stationQuery.saiqu = record.id;
      self.stationVisible = true;
    },

    // 增改 处理
    handleStationOk(e) {
      let self = this;

      e.preventDefault();
      this.form5.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.stationFormData);
          self.saveLoading = true;
          if (self.stationFormData.id > 0) {
            editStation({
              id: self.stationFormData.id,
              name: values.name,
              address: values.address,
            })
              .then((res) => {
                self.$message.success("修改成功");

                self.fetchStationList();

                self.stationFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          } else {
            addStation({
              saiqu: self.stationQuery.saiqu,
              name: values.name,
              address: values.address,
            })
              .then((res) => {
                self.$message.success("新增成功");
                self.fetchStationList();

                self.stationFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },

    //执行官
    onAddZhixingguan() {
      (this.zhixingguanFormData = {
        id: 0,
        name: "",
        show: 1,
      }),
        this.form7.resetFields();
      this.zhixingguanFormVisible = true;
      console.log("zhixingguanFormVisible");
    },

    handleZhixingguanCancel() {
      this.zhixingguanFormVisible = false;
    },
    onEditZhixingguan(record) {
      let self = this;
      this.zhixingguanFormVisible = true;
      getZhixingguanDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form6.setFieldsValue({ ...res.data });
          self.zhixingguanFormData.id = record.id;
          self.zhixingguanFormData = { ...res.data };
        }, 200);
      });
    },
    deleteZhixingguan(record) {
      let self = this;
      zhixingguanDelete({ id: record.id }).then((res) => {
        self.fetchZhixingguanList();
      });
    },

    fetchZhixingguanList() {
      let self = this;
      getZhixingguanList(self.zhixingguanQuery).then((res) => {
        self.zhixingguanList = res.data;
      });
    },

    handleZhixingguan(record) {
      let self = this;
      self.fetchZhixingguanList();
      self.zhixingguanQuery.saiqu = record.id;
      self.zhixingguanVisible = true;
    },

    // 增改 处理
    handleZhixingguanOk(e) {
      let self = this;

      e.preventDefault();
      this.form6.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log(
            "Received valuess of formData: ",
            self.zhixingguanFormData
          );
          self.saveLoading = true;
          if (self.zhixingguanFormData.id > 0) {
            editZhixingguan({
              id: self.zhixingguanFormData.id,
              name: values.name,
              num: values.num,
            })
              .then((res) => {
                self.$message.success("修改成功");

                self.fetchZhixingguanList();

                self.zhixingguanFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          } else {
            addZhixingguan({
              saiqu: self.zhixingguanQuery.saiqu,
              name: values.name,
              num: values.num,
            })
              .then((res) => {
                self.$message.success("新增成功");
                self.fetchZhixingguanList();

                self.zhixingguanFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },

    handleUserList(record, index) {
      this.userListVisible = true;
      this.userFormData.saiqu = record.id;  
      this.fetchUser();
    },
    //cca负责人
    onAddCcaren() {
      (this.ccarenFormData = {
        id: 0,
        name: "",
        show: 1,
      }),
        this.form7.resetFields();
      this.ccarenFormVisible = true;
      console.log("ccarenFormVisible");
    },

    handleCcarenCancel() {
      this.ccarenFormVisible = false;
    },
    onEditCcaren(record) {
      let self = this;
      this.ccarenFormVisible = true;
      getCcarenDetail({ id: record.id }).then((res) => {
        setTimeout(() => {
          self.form7.setFieldsValue({ ...res.data });
          self.ccarenFormData.id = record.id;
          self.ccarenFormData = { ...res.data };
        }, 200);
      });
    },
    deleteCcaren(record) {
      let self = this;
      ccarenDelete({ id: record.id }).then((res) => {
        self.fetchCcarenList();
      });
    },

    fetchCcarenList() {
      let self = this;
      getCcarenList(self.ccarenQuery).then((res) => {
        self.ccarenList = res.data;
      });
    },
    handleCcaren(record) {
      let self = this;
      self.fetchCcarenList();
      self.ccarenQuery.saiqu = record.id;
      self.ccarenVisible = true;
    },
    handleMiniCode(record) {
      let self = this;
      self.MiniCode = 'https://api.ccachina.net/adminapi/sai/getMiniCodeImg?id='+record.id;
      // self.getMiniCode(record.id);
      self.miniCodeVisible = true;
    },
    handleVisit(record) {
      let that = this; 
      // self.getMiniCode(record.id); 
      getVisitData({
        saiqu: record.id, 
      })
        .then((res) => {  
          console.log(res)
          that.visitData = res.data
        })
      that.visitVisible = true;
    }, 
    handleminiCodeOk() {
      let self = this;
      self.miniCodeVisible = false;
    },
    // 增改 处理
    handleCcarenOk(e) {
      let self = this;

      e.preventDefault();
      this.form7.validateFields((err, values) => {
        if (!err) {
          console.log("Received values of form: ", values);
          console.log("Received valuess of formData: ", self.ccarenFormData);
          self.saveLoading = true;
          if (self.ccarenFormData.id > 0) {
            editCcaren({
              id: self.ccarenFormData.id,
              name: values.name,
              num: values.num,
            })
              .then((res) => {
                self.$message.success("修改成功");

                self.fetchCcarenList();

                self.ccarenFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          } else {
            addCcaren({
              saiqu: self.ccarenQuery.saiqu,
              name: values.name,
              num: values.num,
            })
              .then((res) => {
                self.$message.success("新增成功");
                self.fetchCcarenList();

                self.ccarenFormVisible = false;
                self.saveLoading = false;
              })
              .catch((err) => {
                self.$message.error(err.data.msg);
                self.saveLoading = false;
              });
          }
        }
      });
    },

    download() {
      getDownloadUrl(this.queryParam).then((res) => {
        console.log(res);
        window.open(res.data);
      });
    },
    saiquDownloads(type,record){
        window.open(setting.apiBaseURL+'/adminapi/sai/'+type+'?saiqu='+record.id);
    },
    saijiDownloads(type){
      if(!this.queryParam.saiji){
          this.$message.error("请选择赛季");
        return ;
      }
        window.open(setting.apiBaseURL+'/adminapi/sai/'+type+'?saiji='+this.queryParam.saiji);
    },
    downloadjindubiao() {
      if(!this.queryParam.saiji){
          this.$message.error("请选择赛季");
        return ;
      }
        window.open(setting.apiBaseURL+'/adminapi/sai/saiqujindubiao?saiji='+this.queryParam.saiji);
    },
    onSelectChange(selectedRowKeys, selectedRows) {
      this.selectedRowKeys = selectedRowKeys;
      this.selectedRows = selectedRows;
    },
    fetchUser() {
      let that = this; 
      getAdminUserList({
        saiqu: that.userFormData.saiqu
      }).then(
        (res) => {
          that.adminUserList = res.data; 
        }
      );
    },
    addUser() {
      let self = this;
      if (!self.userFormData.user_id) {
        self.$message.error("请选择人员");
        return;
      } 
      console.log(self.userFormData);

      addAdminUser(self.userFormData)
        .then((res) => {
          self.userFormData.user_id = undefined; 
          self.$message.success("新增成功");
          self.fetchUser(); 
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
    deleteUser(record, index) {
      let self = this;
      deleteAdminUser({
        user_id: record.user_id,
        saiqu: self.userFormData.saiqu,
      })
        .then((res) => {
          self.$message.success("删除成功");
          self.adminUserList.splice(index, 1); 
        })
        .catch((err) => {
          self.$message.error(err.data.msg);
        });
    },
  },
  filters: {},
  watch: {},
};
</script>
<style scoped>
.MiniCode{
  margin: 0 auto;
}
</style>
